import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceProfiles {
    lookupService = new APIServiceLookUp();

    async updateInterpreter(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}interpreter/updateInterpreter`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}